import { Divider, FormControl, InputLabel, ListItemIcon, MenuItem, Select, styled } from '@mui/material';

const elementWidth = 175;

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  minWidth: elementWidth,
  margin: theme.spacing(1),
}));

const StyledInputLabel = styled(InputLabel)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '0.75em',
  textTransform: 'uppercase',
  color: theme.palette.grey[400],
  transformOrigin: 'top left',
  transform: 'translate(0, 1.5px) scale(0.75)',
}));

const StyledSelect = styled(Select)(({ theme }) => ({
  maxWidth: elementWidth,
  color: theme.palette.grey[500],
}));

const StyledDivider = styled(Divider)(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));

const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  minWidth: theme.spacing(5),
}));

const StyledDeleteMenuItem = styled(MenuItem)(({ theme }) => ({
  color: theme.palette.error.main,
}));

const StyledDeleteListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  minWidth: theme.spacing(5),
  color: theme.palette.error.main,
}));

const StyledShowMoreLessMenuItem = styled(MenuItem)(({ theme }) => ({
  fontSize: '0.875rem',
  color: theme.palette.grey[400],
}));

const StyledSubtitle = styled('span')({
  position: 'absolute',
  top: '3em',
});

export {
  StyledFormControl,
  StyledInputLabel,
  StyledSelect,
  StyledDivider,
  StyledListItemIcon,
  StyledDeleteMenuItem,
  StyledDeleteListItemIcon,
  StyledShowMoreLessMenuItem,
  StyledSubtitle,
};
